module.exports = __webpack_public_path__ + "static/CACA-d871e4c69a19845c0171d8f22dc26cc0.png";